import { CreateObject, PostObjectResponse } from './metadata';

export interface Audience {
  id: number;
  name: string;
  description: string;
  color_code: string;
  audience_type?: string;
  created_at: string;
  updated_at: string;
}

// Create a class that extends CreateObject similar to StrategicPillarRaw
export class AudienceRaw extends CreateObject {
  id: number = 0;
  name: string = '';
  description: string = '';
  color_code: string = '';
  audience_type: string = '';
  created_at: string = '';
  updated_at: string = '';

  constructor(data?: Partial<Audience>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
  }

  get abstractID(): string {
    return this.id.toString();
  }

  get abstractDate(): string {
    return this.updated_at || this.created_at || new Date().toISOString();
  }

  toPost(changes: AudienceRaw): any {
    return {
      name: changes.name,
      description: changes.description,
      color_code: changes.color_code,
      audience_type: changes.audience_type
    };
  }

  static override parseFromPostResponse(post: PostObjectResponse<AudienceRaw>): PostObjectResponse<AudienceRaw> {
    if (post.updatedData) {
      post.updatedData = Object.assign(new AudienceRaw(), post.updatedData);
    }
    return post;
  }
}
